enum DialogType {
    None = 0,
    Info = 1,
    Error = 2,
    Wait = 3,
    Ask = 4
}
export default DialogType;